export default __webpack_public_path__ + "static/media/solution-detergent.ff7c6bfe.png";